import { Box, Button, Form, Icon, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, ReactElement, useEffect, useState } from 'react'
import { Keyboard } from 'react-native'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { Progress } from '../../comps/Progress'
import { otpStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { useIsMobile } from '../../util/useFontSize'
import { isOsMobile, ProgressTypes, testProps, useWindowDimensions } from '../../util/util'
import { LoginBg } from '../Login/LoginBg'
import CountDownTimer from './CountDownTimer'
import { otpForm } from './FormData'
import OtpMobile from './OtpMobile'
import { styles } from './styles'

interface OtpProps {
  isFromForgotPwd?: boolean
  hide?: boolean
  mobileNumber?: string
  onBack?: () => void
  getOtpEntered?: (otp: string) => void
  isSignUp?: boolean
}

const renderOtpActionButtons = ({
  handleSubmit,
  // values,
  // isValid,
  handleVerifyPress,
  // buttonContainer,
  otpApiHandler,
  themedStyle,
  otpValue,
  isLoading,
  mobileNumber,
}: any): ReactElement => {
  // if (String(otpValue)?.trim()?.length > 5) {
  //   setTimeout(() => {
  //     handleVerifyPress(String(otpValue))
  //   }, 10)
  // }

  const handleOtpSubmitPress = (): void => {
    handleSubmit()
    if (String(otpValue)?.trim()?.length > 5) {
      handleVerifyPress(String(otpValue))
    }
  }
  return (
    <>
      <CountDownTimer count={30} mobile={mobileNumber} />
      <Box {...themedStyle.otpButtonContainer}>
        <Button
          isLoading={otpApiHandler === 'pending' || isLoading}
          disabled={String(otpValue)?.trim()?.length < 6}
          {...testProps('verify-otp-button')}
          color={'BLUE'}
          isFull
          type={'primary'}
          testID="submit-otp"
          onPress={handleOtpSubmitPress}>
          <Text color={'WHITE'}>{otpStrings.verifyOtp}</Text>
        </Button>
      </Box>
    </>
  )
}

// const Otp: FC<OtpProps> = ({ isFromForgotPwd, hide, mobileNumber = '', getOtpEntered, isSignUp }: OtpProps) => {
const Otp: FC<OtpProps> = ({ route: { params } }) => {
  const hide = false
  const mobileNumber = params?.mobileNum
  const isSignUp = params?.isSignUp
  const isFromForgotPwd = params?.isFromForgotPwd ?? false
  const { setSessionVerified, otpVerify, resetAccessToken } = useStores((root) => ({
    setSessionVerified: root.user.session.setSessionVerified,
    otpVerify: root.user.loginVerifyOTP,
    resetAccessToken: root.user.session.resetAccessToken,
  }))
  const navigation = useNavigation()
  // const appState = useRef(AppState.currentState)
  const [otpValue, setOtpValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [verifyOTP, { state }] = useLazyApiData(otpVerify)

  const viewPortWidth = useWindowDimensions()

  useEffect(() => {
    if (state === 'fulfilled') {
      setSessionVerified(true)
      setIsLoading(false)
      navigation?.navigate(Routes.RESET_PASSWORD, { path: Routes.RESET_PASSWORD, isSignUp: true, otp: otpValue })
    } else if (state === 'pending') {
      setIsLoading(true)
    } else if (state === 'rejected') {
      setIsLoading(false)
    }
  }, [navigation, otpValue, setSessionVerified, state])

  const initValues = {
    otp: '',
  }

  // const error = data?.message ?? ''
  // const isErrorVisible = error?.length > 0 ?? false

  const navigateToSetResetPassword = (otp: string) => {
    navigation?.navigate(Routes.RESET_PASSWORD, { path: Routes.RESET_PASSWORD, isSignUp: isSignUp, otp: otp })
  }

  const handleVerifyPress = (otp: string): void => {
    Keyboard.dismiss()
    if (!isFromForgotPwd) {
      isSignUp ? navigateToSetResetPassword(otp) : verifyOTP(otp, mobileNumber)
    } else {
      // if (getOtpEntered) {
      //   getOtpEntered(otp)
      // }
      navigateToSetResetPassword(otp)
    }
  }

  const setFieldValue = (passedData: string) => {
    setOtpValue(passedData)
  }

  const getFormData = (): any[] => {
    const initialFormData = [...otpForm(otpValue, setFieldValue)]
    return initialFormData
  }

  const handleOtpCancelPress = (): any => {
    resetAccessToken()
    navigation?.goBack()
  }

  const renderAction = ({ handleSubmit }: any): ReactElement => {
    return renderOtpActionButtons({
      handleSubmit,
      // values,
      // isValid,
      handleVerifyPress,
      // buttonContainer,
      state,
      themedStyle,
      otpValue,
      isLoading,
      mobileNumber,
    })
  }

  const hideStepProgress = () => {
    return true //isSignUp || !isFromForgotPwd //TODO: check on forgot password flow
  }

  if (hide) {
    return null
  }

  const themedStyle = styles(viewPortWidth)

  const isMobile = useIsMobile()
  if (isMobile) {
    return <OtpMobile params={params} />
  }
  return (
    <LoginBg isSignup={isSignUp}>
      <Box width={viewPortWidth > 432 ? 320 : viewPortWidth - 36} justifyContent="center">
        <ModBox show={!hideStepProgress()} height={5}>
          <Progress hide={hideStepProgress()} type={ProgressTypes.OTP} />
        </ModBox>
        <Box padding={16}>
          <ModBox
            onPress={handleOtpCancelPress}
            show={isOsMobile()}
            {...testProps('back-button')}
            {...themedStyle.backTouchableStyle}>
            <Icon id={'ARROW_BACK'} color={'PRIMARY'} size={24} />
          </ModBox>
          <Spacer size={8} />
          <Text {...themedStyle.enterOtpStyle}>{otpStrings.enterOtp}</Text>
          <Box {...themedStyle.userInfoContainer}>
            <Text {...themedStyle.userInfoStyle}>{otpStrings.weHaveSent6DigitOtp}</Text>
            <Spacer size={5} direction="horizontal" />
            <Text {...themedStyle.mobileNumberStyle}>{mobileNumber}</Text>
            <Box onPress={handleOtpCancelPress} {...testProps('edit-otp-button')} underlayColor={'TRANSPARENT'}>
              <Text {...themedStyle.editStyle}>{otpStrings.editWithBraces}</Text>
            </Box>
            <Spacer size={24} direction="vertical" />
          </Box>
          <Box {...themedStyle.formContainer}>
            <Form
              initialValues={initValues}
              container={DefaultFormContainer}
              formData={getFormData()}
              actionButtons={renderAction}
            />
          </Box>
        </Box>
      </Box>
    </LoginBg>
  )
}

export default Otp
